/**
 * @module plugins
 * @description Plugin store — lists official plugins and provides install/uninstall/toggle actions
 */

import type { ModuleManifest } from '@gzl10/nexus-sdk'
import { pluginsEntity } from './plugins.entity.js'
import { createPluginRoutes } from './plugins.routes.js'

export { toPluginDTO } from './plugins.helpers.js'

export const pluginsModule: ModuleManifest = {
  name: 'plugins',
  label: { en: 'Plugins', es: 'Plugins' },
  icon: 'mdi:puzzle',
  description: { en: 'Plugin store and management', es: 'Tienda y gestión de plugins' },
  type: 'core',
  category: 'settings',
  dependencies: ['logger'],
  definitions: [pluginsEntity],
  routes: createPluginRoutes,
  routePrefix: '/plugins'
}
